import { IServiceSmallMoveState } from './state';
import { IServiceSmallMoveAction } from './action';
import { validateInput, validateLength } from 'commons/ZimssaHelper';

export const defaultState: IServiceSmallMoveState = {
    transportationLicenseNumber: '',
    transportationLicenseImage: '',
    smallMoveValid: false,
};

export interface IServiceSmallMoveReducer {
    (state: IServiceSmallMoveState, action: IServiceSmallMoveAction): IServiceSmallMoveState;
}

export default function serviceSmallMoveReducer(state: IServiceSmallMoveState, action: IServiceSmallMoveAction): IServiceSmallMoveState {
    const { type, value } = action;
    switch (type) {
        case 'SET_STATE':
            if (typeof value === 'object') {
                state = value || state;

            } else {
                state = defaultState;
            }
            break;
        default: state = { ...state, [type]: value, }
            break;
    }

    state = {
        ...state, smallMoveValid: validateInput(state.transportationLicenseNumber.trim()) &&
            validateLength(state.transportationLicenseNumber, 9) &&
            validateInput(state.transportationLicenseImage.trim())
    }
    return state;
}
